import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";

//import { CookieService } from 'angular2-cookie/services/cookies.service';
// import { CookieService, CookieOptions } from 'angular2-cookie/core';
import {CookieModule} from "ngx-cookie";
import {AuthOracleTokenGuard} from "./guards-oracle/auth-oracle-token.guard";
import {AuthTokenGuard} from "./guards/auth-token.guard";

import {AppComponent} from "./app.component";
import {CatalogComponent} from "./components/catalog/catalog.component";
import {HeaderComponent} from "./components/header/header.component";
import {CartComponent} from "./components/cart/cart.component";
import {AppRoutes} from "./app.routes";
import {WelcomeComponent} from "./components/welcome/welcome.component";

import {AuthService} from "./services/auth.service";

import {BootstrapModalModule} from "ng2-bootstrap-modal";

import {Storage} from "./storage/storage";
import {ConfirmComponent} from "./components/detail-pdt/detail-pdt.component";
import {Ng2PaginationModule} from "ng2-pagination";
import {SelectModule} from "ng2-select";
import {FilterProductsPipe} from "./pipes/filter-products.pipe";
import {Ng2FilterPipeModule} from "ng2-filter-pipe";
import {SafeUrlPipe} from "./pipes/safe-url.pipe";
import { SendOracleCartComponent } from './components/send-oracle-cart/send-oracle-cart.component';

@NgModule({
  declarations: [
    AppComponent,
    CatalogComponent,
    HeaderComponent,
    CartComponent,
    WelcomeComponent,
    ConfirmComponent,
    FilterProductsPipe,
    SafeUrlPipe,
    SendOracleCartComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutes,
    BootstrapModalModule,
    Ng2PaginationModule,
    SelectModule,
    Ng2FilterPipeModule,
    CookieModule.forRoot(),
  ],
  providers: [AuthService, AuthTokenGuard, AuthOracleTokenGuard, Storage],
  entryComponents: [ConfirmComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts